import { Box } from '@everlywell/ui-kit';
import Carousel, { CarouselProps } from 'components/Carousel';
import React from 'react';
import { SwiperClass, SwiperProps, SwiperSlideProps } from 'swiper/react';

export type MultipleCardsSwiperProps = {
  /**
   * Array of cards to be displayed in the carousel
   */
  cards: React.JSX.Element[];
  /**
   * Configuration for the breakpoints of the carousel
   */
  breakpointConfig?: SwiperClass['params']['breakpoints'];
  slideStyles?: SwiperSlideProps['style'];
  showPagination?: boolean;
  hasFadeOnEdges?: CarouselProps['hasFadeOnEdges'];
  fadeBgColor?: CarouselProps['fadeBgColor'];
  carouselStyles?: CarouselProps['style'];
} & Partial<SwiperProps> &
  Partial<CarouselProps>;

/**
 * [Add the description for what this component does here].
 */
const MultipleCardsSwiper = ({
  cards,
  breakpointConfig = {
    0: {
      slidesPerView: 1.3,
      centeredSlides: true,
    },
    // Sizes from ui-kit
    900: {
      slidesPerView: 2,
    },
    1200: {
      slidesPerView: 4.2,
    },
  },
  slideStyles,
  fadeBgColor,
  showPagination = true,
  hasFadeOnEdges = false,
  mousewheel = false,
  freeMode = false,
  carouselStyles,
  ...rest
}: MultipleCardsSwiperProps) => (
  <Box
    sx={{
      '& .swiper-wrapper': {
        alignItems: 'stretch',
        paddingBottom: '24px',
      },
      '& .swiper-slide': {
        height: 'auto',
        ...slideStyles,
      },
      '& > .swiper': {
        paddingBottom: '60px',

        '@media screen and (max-width: 768px)': {
          paddingBottom: '24px',
        },
      },
    }}
  >
    <Carousel
      spaceBetween={16}
      data-testid="cards-carousel-swiper-wrapper"
      breakpoints={breakpointConfig}
      pagination={cards.length + 1 > 1}
      arrowPosition="bottom"
      showPagination={showPagination}
      style={{ ...carouselStyles, display: 'flex', alignItems: 'stretch' }}
      slideStyle={{
        display: 'flex',
      }}
      hasFadeOnEdges={hasFadeOnEdges}
      fadeBgColor={fadeBgColor}
      mousewheel={mousewheel}
      freeMode={freeMode}
      {...rest}
    >
      {cards.map((card, index) => (
        <Box
          display={'flex'}
          flexDirection={'column'}
          key={`card-${index}`}
          width="100%"
        >
          {card}
        </Box>
      ))}
    </Carousel>
  </Box>
);

export default MultipleCardsSwiper;
